import { render } from "./IosProducts.vue?vue&type=template&id=230380d4"
import script from "./IosProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./IosProducts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/products/ios/IosProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "230380d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('230380d4', __exports__)) {
    console.log('reload')
    api.reload('230380d4', __exports__)
  }
  
  module.hot.accept("./IosProducts.vue?vue&type=template&id=230380d4", () => {
    console.log('re-render')
    api.rerender('230380d4', render)
  })

}


export default __exports__